import { render, staticRenderFns } from "./ElComments.vue?vue&type=template&id=01d24efe"
import script from "./ElComments.vue?vue&type=script&lang=js"
export * from "./ElComments.vue?vue&type=script&lang=js"
import style0 from "./ElComments.vue?vue&type=style&index=0&id=01d24efe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports